import React from "react";
import ICatalog_Item from "../../../models/ICatalog_Item";
import styled from "styled-components";
import OwLabel from "../../shared/OwLabel/OwLabel";
import "./InventoryMobileRows.scss";

type Props = {
    dataSet: ICatalog_Item[];
    showItemDetailView: (item: ICatalog_Item) => void;
};

export const InventoryMobileRows = (props: Props) => {
    return (
        <div className={"InventoryMobileRows"}>
            {props.dataSet.map((item, index) => {
                return (
                    <RowWrapper
                        key={item.guid}
                        className={"InventoryMobileRow"}
                        onClick={() => {
                            props.showItemDetailView(item);
                        }}>
                        <div className={"d-flex justify-content-between"}>
                            <NameWrapper>{item.name}</NameWrapper>
                            <div className={"text-end"}>
                                <div>
                                    <OwLabel title={"qty"} className={"me-2"} postText={":"} isBold={true} />
                                    {item.qty_on_hand}
                                </div>
                                <div>
                                    <OwLabel title={"tap_to_adjust"} className={"text-small text-muted"} />
                                </div>
                            </div>
                        </div>
                        <div className={"text-small mb-3"}>{item.description}</div>
                        <div className={"mb-3"}>{item.sku}</div>
                        <div>
                            {item.row || ""}
                            {item.bin || ""}
                        </div>
                    </RowWrapper>
                );
            })}
            {!props.dataSet.length ? (
                <div className={"text-center pb-5"}>
                    <OwLabel title={"no_items_found"} />
                </div>
            ) : null}
        </div>
    );
};

const RowWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.7rem;

    &:nth-child(odd) {
        background-color: var(--secondary-bg-color);
    }
`;

const NameWrapper = styled.div`
    width: 280px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
